import dayjs from 'dayjs';

export const nowDateToStr = () => {
  let now = new Date();

  // 연도, 월, 일, 시간, 분 추출
  let year = now.getFullYear();
  let month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
  let day = String(now.getDate()).padStart(2, '0');
  let hour = String(now.getHours()).padStart(2, '0');
  let minute = String(now.getMinutes()).padStart(2, '0');
  return `${year}${month}${day}${hour}${minute}`;
};
export const strToLocalDateTime = (dateStr) => {
  let year = dateStr.substring(0, 4);
  let month = dateStr.substring(4, 6);
  let day = dateStr.substring(6, 8);
  let hour = dateStr.substring(8, 10);
  let minute = dateStr.substring(10, 12);

  // T를 포함한 형식으로 변환
  return `${year}-${month}-${day}T${hour}:${minute}:00`; // "T" 추가
};

export const formatNumber = (value) => {
  if (isNaN(value)) return 0;
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const toLocalDateTimeToStr = (date) => {
  if (!date) return '-';
  return dayjs(date.replace("'T'", ' ')).format('YYYY.MM.DD HH:mm');
};

export const toLocalDateTimeToDate = (date) => {
  if (!date) return '-';
  return dayjs(date.replace("'T'", ' ')).format('YYYY.MM.DD');
};
export const formatNumber2 = (value, options) => {
  if (this.isEmpty(value) || isNaN(value) || value === 0) return '-';
  let dl = options['decimalLength'] || 0;
  let ts = options['thousandsSep'] || ',';
  let ty = options['type'] || '';
  let ut = options['unit'] || '';

  if (ty !== '') value = value * 100;
  value = parseFloat(value);
  let re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
  let num = value.toFixed(Math.max(0, ~~dl));
  return `${num.replace(new RegExp(re, 'g'), '$&' + ts)}${ut}`;
};
export const getPhoneFormat = (num, type = 1) => {
  if (!num) return '';
  let formatNum = '';
  try {
    if (num.length === 11) {
      if (type === 0) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
      } else {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      }
    } else if (num.length === 8) {
      formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else {
      if (num.indexOf('02') === 0) {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        }
      } else {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        }
      }
    }
  } catch (e) {
    formatNum = num;
  }
  return formatNum;
};
export const formatDate = (value, options = { flag: false }) => {
  let text = '';
  let flag = options['flag'] || false;
  if (value.length === 6) {
    text = flag
      ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월`
      : `${value.substring(0, 4)}-${value.substring(4, 6)}`;
  } else if (value.length === 8) {
    text = flag
      ? `${value.substring(0, 4)}년 ${value.substring(4, 6)}월 ${value.substring(6, 8)}일`
      : `${value.substring(0, 4)}-${value.substring(4, 6)}-${value.substring(6, 8)}`;
  } else if (value.length > 8) {
    text = value;
  } else {
    text = '-';
  }
  return text;
};
export const formatRpad = (target, value, n) => {
  return `${target}${Array(n - target.length + 1).join(value || '0')}`;
};
export const formatNumberToPhone = (value) => {
  if (this.isEmpty(value)) return '';
  return value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
};
export const formatBizNum = (value) => {
  if (this.isEmpty(value)) return '';
  return value.replace(/([0-9]{3})([0-9]{2})([0-9]{5})/, '$1-$2-$3');
};
export const formatLpad = (target, value, n) => {
  if (this.isEmpty(target)) return '';
  target = target.toString();
  return `${Array(n - target.length + 1).join(value || '0')}${target}`;
};
export const formatStringBirth = (birth = '20010101') => {
  if (birth.length !== 8) return '';
  return `${birth.substr(0, 4)}.${birth.substr(4, 2)}.${birth.substr(6, 2)}`;
};
